import type { ExternalLinkType } from "#public"

// The web build's half of the open-elsewhere contract (the desktop build's is
// ../electron/ExternalLink, over a real second window — a browser tab is not
// something it has).
//
// A link that is *in the document*, not one JavaScript builds and clicks for
// the user: a link activation is a *navigation*, which the pop-up blocker does
// not police, while anything opened on their behalf is a pop-up and Safari
// decides per *site* whether to allow one — which is why identical code opened
// a tab from the standalone app and returned null from an embedding host on
// another origin. That blocker refused even `window.open("", "_blank")` there,
// so it was never the url (780 characters) nor the gesture: it was opening it
// in code at all. (Cross-Origin-Opener-Policy, which that host does send, was
// measured and is not involved — WebKit opens the tab with and without it.)
//
// So the anchor is rendered rather than synthesized. Nothing can refuse it,
// and middle-click, copy-link and keyboard activation come with it.
export const ExternalLink: ExternalLinkType = ({ children, href, ...props }) => (
  <a
    // The bare `#/...` is enough, spelling the document out is not needed:
    // a fragment-only href is a same-document navigation only while it stays
    // in this browsing context, and `target` means it cannot — the browser has
    // to create the new context first, and there the whole url is resolved
    // against this one. Measured in Chromium; not re-measured in WebKit, which
    // is where the old synthetic-click version had its trouble.
    href={href}
    rel="noopener"
    target="_blank"
    {...props}
  >
    {children}
  </a>
)
